<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/supplier/page"
        getKey="rows" :columns="columns">

    </yi_curd_table>

  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_wms_purchase_receipt_supplier_information',
  components: {
  },
  data() {
    return {
      columns: [ {
        label: 'gongyingshangbianma',
        prop: 'code',
        width: 150,
      }, {
        label: 'gongyingshangmingcheng',
        prop: 'name',
        width: 130,
      }, {
        label: 'gongyingshangdizhi',
        prop: 'address',
        width: 180,
      }, {
        label: 'lianxiren',
        prop: 'contacts',
        // width: 130,
      },{
        label: 'lianxifangshi',
        prop: 'contactsInfo',
        width: 130,
      }, {
        label: 'youxiang',
        prop: 'email',
        width: 130,
      },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname',
          width: 130,
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 130,
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        // orderBy: 'createTime desc,triggerTime asc',
      }
      this.yt.SELECT_URL = "/web/supplier/listByIds"
      this.yt.SELECT_RESULT_KEY = "data"
      this.yt.SELECT_ID = "id"
      this.yt.SELECT_TITLE = "name"
      this.yt.get(1);
    }, 300)
  },

  methods: {

  }
};
</script>
